<ion-header>
  <ion-toolbar>
    <ion-title>{{ modalTitle }}</ion-title>
    <ion-buttons slot="start">
      <ion-button (click)="dismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-buttons slot="end" *ngIf="!isView">
      <ion-button (click)="save()" [disabled]="saving">
        <ion-spinner *ngIf="saving" name="lines-small"></ion-spinner>
        <span *ngIf="!saving">{{ isEdit ? "Update" : "Save" }}</span>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <form [formGroup]="form">
    <!-- Personal Information -->
    <div class="section">
      <ion-list>
        <ion-list-header>
          <ion-label>Personal Information</ion-label>
        </ion-list-header>

        <ion-item>
          <ion-label position="stacked">SSN</ion-label>
          <ion-input
            formControlName="ssn"
            placeholder="Enter your SSN"
            type="text"
            maxlength="11"
            [readonly]="isView"
          >
          </ion-input>
        </ion-item>

        <ion-item>
          <ion-label position="stacked">Tax ID</ion-label>
          <ion-input
            formControlName="taxId"
            placeholder="Enter your Tax ID"
            type="text"
            [readonly]="isView"
          >
          </ion-input>
        </ion-item>
      </ion-list>
    </div>

    <!-- Payment Method Type Selection -->
    <div class="section" *ngIf="!isView">
      <ion-list>
        <ion-list-header>
          <ion-label>Payout Method Type</ion-label>
        </ion-list-header>
        <ion-radio-group
          [(ngModel)]="selectedMethodType"
          (ionChange)="onMethodTypeChange()"
          [ngModelOptions]="{ standalone: true }"
        >
          <ion-item *ngFor="let type of paymentMethodTypes">
            <ion-radio [value]="type" slot="start"></ion-radio>
            <ion-label>{{ paymentMethodTypeLabels[type] }}</ion-label>
          </ion-item>
        </ion-radio-group>
      </ion-list>
    </div>

    <!-- Zelle Fields -->
    <div class="section" *ngIf="selectedMethodType === 'Zelle'">
      <ion-list>
        <ion-list-header>
          <ion-label>Zelle Information</ion-label>
        </ion-list-header>

        <ion-item>
          <ion-label position="stacked">Full Name *</ion-label>
          <ion-input
            formControlName="zelleFullName"
            placeholder="Enter your full name"
            [readonly]="isView"
          >
          </ion-input>
        </ion-item>

        <ion-item>
          <ion-label position="stacked">Email or Phone Number *</ion-label>
          <ion-input
            formControlName="zelleEmailOrPhone"
            placeholder="Enter email or phone number"
            [readonly]="isView"
          >
          </ion-input>
        </ion-item>

        <ion-item>
          <ion-label position="stacked">Bank Name *</ion-label>
          <ion-input
            formControlName="zelleBankName"
            placeholder="Enter bank name"
            [readonly]="isView"
          >
          </ion-input>
        </ion-item>
      </ion-list>
    </div>

    <!-- Bank Account Fields -->
    <div class="section" *ngIf="selectedMethodType === 'ContaBancaria'">
      <ion-list>
        <ion-list-header>
          <ion-label>Bank Account Information</ion-label>
        </ion-list-header>

        <ion-item>
          <ion-label position="stacked">Bank Name *</ion-label>
          <ion-input
            formControlName="bankAccountBankName"
            placeholder="Enter bank name"
            [readonly]="isView"
          >
          </ion-input>
        </ion-item>

        <ion-item>
          <ion-label position="stacked">Account Holder Name *</ion-label>
          <ion-input
            formControlName="bankAccountHolderName"
            placeholder="Enter account holder name"
            [readonly]="isView"
          >
          </ion-input>
        </ion-item>

        <ion-item>
          <ion-label position="stacked">Bank Code *</ion-label>
          <ion-input
            formControlName="bankAccountBankCode"
            placeholder="Enter bank code"
            [readonly]="isView"
          >
          </ion-input>
        </ion-item>

        <ion-item>
          <ion-label position="stacked">Account Number *</ion-label>
          <ion-input
            formControlName="bankAccountNumber"
            placeholder="Enter account number"
            [readonly]="isView"
          >
          </ion-input>
        </ion-item>
      </ion-list>
    </div>

    <!-- International Account Fields -->
    <div class="section" *ngIf="selectedMethodType === 'ContaInternacional'">
      <ion-list>
        <ion-list-header>
          <ion-label>International Account Information</ion-label>
        </ion-list-header>

        <ion-item>
          <ion-label position="stacked">Bank Name *</ion-label>
          <ion-input
            formControlName="intlAccountBankName"
            placeholder="Enter bank name"
            [readonly]="isView"
          >
          </ion-input>
        </ion-item>

        <ion-item>
          <ion-label position="stacked">SWIFT Code *</ion-label>
          <ion-input
            formControlName="intlAccountSwiftCode"
            placeholder="Enter SWIFT code"
            [readonly]="isView"
          >
          </ion-input>
        </ion-item>

        <ion-item>
          <ion-label position="stacked">Account Number *</ion-label>
          <ion-input
            formControlName="intlAccountNumber"
            placeholder="Enter account number"
            [readonly]="isView"
          >
          </ion-input>
        </ion-item>

        <ion-item>
          <ion-label position="stacked">IBAN</ion-label>
          <ion-input
            formControlName="intlAccountIban"
            placeholder="Enter IBAN (optional)"
            [readonly]="isView"
          >
          </ion-input>
        </ion-item>

        <ion-item>
          <ion-label position="stacked">Account Holder Name *</ion-label>
          <ion-input
            formControlName="intlAccountHolderName"
            placeholder="Enter account holder name"
            [readonly]="isView"
          >
          </ion-input>
        </ion-item>
      </ion-list>
    </div>

    <!-- Save Button for Mobile -->
    <div class="mobile-save-button" *ngIf="!isView">
      <ion-button expand="block" (click)="save()" [disabled]="saving">
        <ion-spinner
          *ngIf="saving"
          name="lines-small"
          slot="start"
        ></ion-spinner>
        {{ isEdit ? "Update Payout Method" : "Save Payout Method" }}
      </ion-button>
    </div>
  </form>
</ion-content>
